import React, { FC } from 'react';

export interface ILine {
    color: string,
    position: number
}

interface IProps {
    scale: number,
    extraLines?: ILine[]
}

const BarLines: FC<IProps> = (props) => {
    const { scale, extraLines } = props
    var majorLines = [];
    var minorLines = [];

    const maxLine = 89 / scale;
    const lineSpace = Math.ceil(5 / scale);
    var majorSpace = Math.ceil(10 / scale);
    majorSpace = lineSpace * Math.round(majorSpace / lineSpace);
    for (var i = 0; i < maxLine - 1; i += lineSpace) {
        if (i % majorSpace === 0) {
            majorLines.push(i);
        } else {
            minorLines.push(i);
        }
    }

    return (
        <div className="BarLines">
            {
                majorLines.map(x => {
                    return <div key={"majorLine" + x} className="BarLine major" style={{ left: x * 5 * scale }} />
                })
            }
            {
                majorLines.map(x => {
                    return <div key={"label" + x} className="BarLabel" style={{ left: x * 5 * scale }}>{x}</div>
                })
            }
            {
                minorLines.map(x => {
                    return <div key={"minorLine" + x} className="BarLine minor" style={{ left: x * 5 * scale }} />
                })
            }

            {
                extraLines?.map((line, idx) => (
                    <div key={idx} className="extraLine" style={{ left: line.position * 5 * scale, backgroundColor: line.color }} />
                ))
            }
        </div>
    )
}

export default BarLines;